import React, { Component } from 'react'
import './Popup.css';
import styles from "../../index";

class Popup extends Component {
  render() {
    let dialog = (
        <div className='fixed inset-0 bg-black bg-opacity-30 backdrop-blur-sm'>
            <div className='dialogStyles'>
                <div>{this.props.children}</div>
                <button className='dialogCloseButtonStyles' onClick={this.props.onClose}>OK</button>
            </div>
        </div>
        );

        if (! this.props.isOpen) {
            dialog = null;
        }
        return (
            <div>
                {dialog}
            </div>
        );
    }
}

export default Popup;